import * as Styles from './HeaderLinks.styles';

export type HeaderLink = {
  to: string;
  active: boolean;
  label: string;
  state?: any;
};

export interface HeaderLinksProps {
  links: HeaderLink[];
}

const HeaderLinksComponent = ({ links, ...props }: HeaderLinksProps): JSX.Element => {
  return (
    <Styles.LinksContainer {...props}>
      {links.map((link: HeaderLink, linkIndex: number) => (
        <Styles.HeaderLink
          key={linkIndex.toString()}
          to={link.to}
          $active={link.active}
          state={link.state}
        >
          {link.label}
        </Styles.HeaderLink>
      ))}
    </Styles.LinksContainer>
  );
};

export default HeaderLinksComponent;
